export default __webpack_public_path__ + "assets/337336d7e90ecdde7c39f80f4c723741.jpg";